// Generated by purs version 0.15.0
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Int from "../Data.Int/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Money_Rounded from "../Data.Money.Rounded/index.js";
import * as Data_Numeric from "../Data.Numeric/index.js";
import * as Data_Semiring from "../Data.Semiring/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Restaumatic_Analytics_Tracking_Event from "../Restaumatic.Analytics.Tracking.Event/index.js";
var itemValue = function (v) {
    return Data_Money_Rounded.toNumber(v.price) * Data_Int.toNumber(v.quantity);
};
var itemToContent = function (v) {
    return {
        id: v.name,
        quantity: v.quantity
    };
};
var toPlatformEvent = function (currency) {
    var purchase = function (v) {
        return {
            contents: Data_Functor.map(Data_Functor.functorArray)(itemToContent)(v.items),
            value: Data_Money_Rounded.toNumber(v.total),
            currency: currency
        };
    };
    var beginCheckout = function (v) {
        return {
            contents: Data_Functor.map(Data_Functor.functorArray)(itemToContent)(v.items),
            value: Data_Numeric.sum(Data_Foldable.foldableArray)(Data_Numeric.additiveNumber)(Data_Functor.map(Data_Functor.functorArray)(itemValue)(v.items)),
            num_items: Data_Foldable.length(Data_Foldable.foldableArray)(Data_Semiring.semiringInt)(v.items),
            currency: currency
        };
    };
    var addToCart = function (item) {
        return {
            content_type: "product",
            contents: [ itemToContent(item) ],
            value: itemValue(item),
            currency: currency
        };
    };
    return function (v) {
        if (v instanceof Restaumatic_Analytics_Tracking_Event.AddToCart) {
            return new Data_Maybe.Just({
                name: "AddToCart",
                value: Foreign_Generic_Class.encode(Foreign_Generic_Class.recordEncode()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)({
                    reflectSymbol: function () {
                        return "value";
                    }
                })(Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.numberEncode)))({
                    reflectSymbol: function () {
                        return "currency";
                    }
                })(Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.stringEncode)))({
                    reflectSymbol: function () {
                        return "contents";
                    }
                })(Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.arrayEncode(Foreign_Generic_Class.recordEncode()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)({
                    reflectSymbol: function () {
                        return "quantity";
                    }
                })(Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.intEncode)))({
                    reflectSymbol: function () {
                        return "id";
                    }
                })(Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.stringEncode)))))))({
                    reflectSymbol: function () {
                        return "content_type";
                    }
                })(Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.stringEncode))))(addToCart(v.value0))
            });
        };
        if (v instanceof Restaumatic_Analytics_Tracking_Event.LocateMe) {
            return Data_Maybe.Nothing.value;
        };
        if (v instanceof Restaumatic_Analytics_Tracking_Event.RemoveFromCart) {
            return Data_Maybe.Nothing.value;
        };
        if (v instanceof Restaumatic_Analytics_Tracking_Event.BeginCheckout) {
            return new Data_Maybe.Just({
                name: "InitiateCheckout",
                value: Foreign_Generic_Class.encode(Foreign_Generic_Class.recordEncode()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)({
                    reflectSymbol: function () {
                        return "value";
                    }
                })(Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.numberEncode)))({
                    reflectSymbol: function () {
                        return "num_items";
                    }
                })(Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.intEncode)))({
                    reflectSymbol: function () {
                        return "currency";
                    }
                })(Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.stringEncode)))({
                    reflectSymbol: function () {
                        return "contents";
                    }
                })(Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.arrayEncode(Foreign_Generic_Class.recordEncode()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)({
                    reflectSymbol: function () {
                        return "quantity";
                    }
                })(Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.intEncode)))({
                    reflectSymbol: function () {
                        return "id";
                    }
                })(Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.stringEncode))))))))(beginCheckout(v.value0))
            });
        };
        if (v instanceof Restaumatic_Analytics_Tracking_Event.Purchase) {
            return new Data_Maybe.Just({
                name: "Purchase",
                value: Foreign_Generic_Class.encode(Foreign_Generic_Class.recordEncode()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)({
                    reflectSymbol: function () {
                        return "value";
                    }
                })(Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.numberEncode)))({
                    reflectSymbol: function () {
                        return "currency";
                    }
                })(Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.stringEncode)))({
                    reflectSymbol: function () {
                        return "contents";
                    }
                })(Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.arrayEncode(Foreign_Generic_Class.recordEncode()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)({
                    reflectSymbol: function () {
                        return "quantity";
                    }
                })(Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.intEncode)))({
                    reflectSymbol: function () {
                        return "id";
                    }
                })(Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.stringEncode))))))))(purchase(v.value0))
            });
        };
        if (v instanceof Restaumatic_Analytics_Tracking_Event.SetCheckoutOption) {
            return Data_Maybe.Nothing.value;
        };
        throw new Error("Failed pattern match at Restaumatic.Analytics.Tracking.Facebook (line 48, column 28 - line 54, column 39): " + [ v.constructor.name ]);
    };
};
export {
    toPlatformEvent
};
//# sourceMappingURL=index.js.map
